import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import authModal from './modules/authModal'

Vue.use(Vuex)

const getters = {
  token: (state) => state.user.token,
  name: (state) => state.user.name,
  isLogin: (state) => state.user.isLogin,
  userInfo: (state) => state.user.userInfo,
}

const store = new Vuex.Store({
  modules: {
    user,
    authModal,
  },
  getters,
})

export default store
